import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';

export default class Proba extends Component {
  constructor(PropTypes) {
    super(PropTypes);
    this.state = {
      startDate: moment(),
	  hits: new Date(),
	  todos: this.props.todos
    };
	//this.handleChange = this.handleChange.bind(this);
  }
    handleChange(date) {
    this.setState({
      startDate: date
	 // hits: date.format('DD-MM-YYYY')
    })
	//this.setState({hits: date})
	//const {value} = {props.hits}
	var test 
	//let Color {Red = 1, Green, Blue}
    let colorName: string = date.format('DD-MM-YYYY');
	//var myData =[]
	this.setState({hits: this.state.startDate.format('DD-MM-YYYY')})
	sessionStorage.setItem(colorName, date.format('DD-MM-YYYY'))
	var cachedHits = sessionStorage.getItem(colorName)
	this.setState({ todos: cachedHits });
	//done (todo) {
    //var todos = this.props.todos;
    //todos.splice(todos.indexOf(todo), 1);
    //localStorage.setItem('todos', JSON.stringify(todos));
    //this.setState({ todos: todos });
  //},
	//onRes(cachedHits){return cachedHits;}
	//const cachedHits = localStorage.setItem(key, this.state.startDate.format('DD-MM-YYYY'));
	//const {value} = {props.hits}
	//const cachedHits = localStorage.getItem(this.props.hits);
	//localStorage.setItem(key, JSON.stringify(result.hits));
	//this.setState({hits: date.format('DD-MM-YYYY')})
    //this.onHit()
	//console.log(date, this.state.hits, this.handleChange.bind(this));
	console.log(date.format('DD-MM-YYYY'), colorName, cachedHits, this.props.hits);
	//const cachedHits = localStorage.setItem(key, JSON.stringify(props.state.hits));
	//const {value} = 
	//const {value} = JSON.parse(date);
	//const {value} = date.format('DD-MM-YYYY');
	//const cachedHits = localStorage.getItem({date})
		//const cachedHits = localStorage.getItem(this.props.date.format('DD-MM-YYYY'))
	//const cachedHits = localStorage.getItem(this.date.format('DD-MM-YYYY'));
	//const cachedHits = localStorage.getItem(this.state.hits.format('DD-MM-YYYY'));
	 //this.setState({hits: date.format('DD-MM-YYYY')})
	//const {value} = this.hits;
	// const cachedHits = localStorage.getItem(value);
   // if (cachedHits) {
    //  this.setState({ hit: JSON.parse(cachedHits) });
    //  return;
    //}
	//localStorage.getItem(date.format('DD-MM-YYYY'));
	//localStorage.setItem(key, JSON.stringify(result.hits));
	console.log(test);
}

togHit (e) {
  e && e.preventDefault()
    this.setState({hits: this.state.date})
	const {value} = this.hits;
	 const cachedHits = localStorage.getItem(value);
    if (cachedHits) {
      this.setState({ hits: JSON.parse(cachedHits) });
      return;
    }
console.log(this.hits)
//this.setState({startEvent: this.state.ExampleCustomInput})
}
  onHit(e){
    e && e.preventDefault();

    const { value } = this.state.date;

    if (value === '') {
      return;
    }
 const cachedHits = localStorage.getItem(value);
    if (cachedHits) {
      this.setState({ hits: JSON.parse(cachedHits) });
      return;
    }
    fetch(value)
      .then(response => response.json())
      .then(result => this.onSetResult(result.hits));
  
  
}
 onSetResult = (result, key) => {
    localStorage.setItem(key, JSON.stringify(result.hits));
    this.setState({ hits: result.hits });
  }
 onRes(result){
    console.log(result, 'result');
	this.setState({ hits: result });
  }
//onPrint={event => this.setState({ value: event.target.value })}
  render() {
    return (
	  <div className="index">
      <DatePicker
	  placeholderText='Predložite termin'
        selected={this.state.startDate}
        onChange={this.handleChange.bind(this)}>
        </DatePicker>
		<br />
		
		<button className="square" onClick={() => alert('click')}>
        <p>poslednje predloženo:</p>{this.state.todos}
      </button></div>
    );
  }


}
Proba.propTypes = {
  hits: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/components/Proba.js